export const Types = {
  GET_BANNERS: 'newspapers/GET_BANNERS',
  SET_BANNERS: 'newspapers/SET_BANNERS',
  GET_RECENTS: 'newspapers/GET_RECENTS',
  SET_RECENTS: 'newspapers/SET_RECENTS',
  GET_REGIONALS: 'newspapers/GET_REGIONALS',
  SET_REGIONALS: 'newspapers/SET_REGIONALS',
  GET_HIGHLIGHTS: 'newspapers/GET_HIGHLIGHTS',
  SET_HIGHLIGHTS: 'newspapers/SET_HIGHLIGHTS',
  GET_FAVORITES: 'newspapers/GET_FAVORITES',
  SET_FAVORITES: 'newspapers/SET_FAVORITES',
  GET_SEARCH: 'newspapers/GET_SEARCH',
  SET_SEARCH: 'newspapers/SET_SEARCH',
};

const INITIAL_STATE = {
  banners: { loading: false, data: [] },
  recents: { loading: false, data: [] },
  regionals: { loading: false, data: [] },
  highlights: { loading: false, data: [] },
  favorites: { loading: false, data: [] },
  search: { loading: false, data: [] },
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.GET_BANNERS:
      return { ...state, banners: { ...state.banners, loading: true } };

    case Types.SET_BANNERS:
      return {
        ...state,
        banners: { ...state.banners, loading: false, ...action.payload },
      };

    case Types.GET_RECENTS:
      return { ...state, recents: { ...state.recents, loading: true } };

    case Types.SET_RECENTS:
      return {
        ...state,
        recents: { ...state.recents, loading: true, ...action.payload },
      };

    case Types.GET_REGIONALS:
      return { ...state, regionals: { ...state.regionals, loading: true } };

    case Types.SET_REGIONALS:
      return {
        ...state,
        regionals: { ...state.regionals, loading: false, ...action.payload },
      };

    case Types.GET_HIGHLIGHTS:
      return { ...state, highlights: { ...state.highlights, loading: true } };

    case Types.SET_HIGHLIGHTS:
      return {
        ...state,
        highlights: { ...state.highlights, loading: false, ...action.payload },
      };

    case Types.GET_FAVORITES:
      return { ...state, favorites: { ...state.favorites, loading: true } };

    case Types.SET_FAVORITES:
      return {
        ...state,
        favorites: { ...state.favorites, loading: false, ...action.payload },
      };

    case Types.GET_SEARCH:
      return { ...state, search: { ...state.search, loading: true } };

    case Types.SET_SEARCH:
      return {
        ...state,
        search: { ...state.search, loading: false, ...action.payload },
      };

    default:
      return state;
  }
};

export const Creators = {
  getBanners: () => ({ type: Types.GET_BANNERS }),
  getRecents: () => ({ type: Types.GET_RECENTS }),
  getRegionals: () => ({ type: Types.GET_REGIONALS }),
  getHighlights: () => ({ type: Types.GET_HIGHLIGHTS }),
  getFavorites: customerId => ({
    type: Types.GET_FAVORITES,
    payload: customerId,
  }),
  getSearch: params => ({
    type: Types.GET_SEARCH,
    payload: params,
  }),
  setNewspapers: (type, data) => ({
    type,
    payload: { data },
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/newspapers.js